export default __webpack_public_path__ + "57b87a734d3dbcdee2abf35cc2004964.png";